import * as types from '../mutation-types'
import { UTILS } from '../../utils'
import { API } from '../../api'
import { GROUP_DATA_MANAGER, RECORD_DATA_MANAGER } from '../../data'

export default {
    namespaced: true,
    state: {
        gotGroupData: false,
        groupArr: [],
        groupData: [],
        newGroupId: 0,
        groupDataList: [],
        chooseId: 0,
        choosedGroup: {},
        checkedGroup: false,
        newGroupName: '',
        showChangeGroup: false,
        selectedGroupDataList: [],
        recentGroupList: [],
    },
    getters: {},
    mutations: {
        [types.GROUP_INIT_LIST](state, cbFunc) {
            // 已经拉取过了就不拉了
            if (state.gotGroupData) {
                return;
            }
            API.getGroupList({}, function (data) {
                if (data.length > 0) {
                    state.gotGroupData = true;
                    var resultData = GROUP_DATA_MANAGER.getGroupData(data);
                    state.groupData = resultData;
                    
                    if(typeof(cbFunc) == 'function'){
                        cbFunc();
                    }
                }
                console.log("types.GROUP_INIT_LIST---初始化分组列表", state.groupData)
            })
        },
        [types.GROUP_INIT_GROUP_LIST](state, data) {
            if (state.gotGroupData) { return; }
            state.gotGroupData = true;
            state.groupData = GROUP_DATA_MANAGER.getGroupData(data);
            console.log("types.GROUP_INIT_LIST---初始化分组列表", state.groupData)
        },
        [types.GROUP_INIT_GROUP_DATA](state) {
            var personInfo = AppFate.$store.state.detail.personInfo,
                groupId = personInfo && personInfo.f_group ? parseInt(personInfo.f_group) : 0, 
                groupIndex = UTILS.getIdIndexInObjectArray(state.groupData, groupId),
                defaultId = 0, 
                defaultIndex = UTILS.getIdIndexInObjectArray(state.groupData, defaultId);
            // console.error('initGroupData-------', groupId)
            state.checkedGroup = true;
            if(groupId != 0){
                state.groupData[groupIndex]['choosed'] = true;
                state.groupData[defaultIndex]['choosed'] = false;
            }else {
                if(state.groupData[defaultIndex]) {
                    state.groupData[defaultIndex]['choosed'] = true;
                }
            }
            state.chooseId = groupId;
            state.choosedGroup = GROUP_DATA_MANAGER.getGroupDataById(state.groupData, groupId);
        },
        [types.GROUP_RESET_CHOOSE_GROUP_DATA](state) {
            // 重置选择分组数据
            var chooseId = parseInt(state.chooseId), newId = 0;
            if(chooseId != 0){
                var chooseIndex = UTILS.getIdIndexInObjectArray(state.groupData, chooseId);
                var index = UTILS.getIdIndexInObjectArray(state.groupData, newId);
                state.groupData[chooseIndex]['choosed'] = false;
                state.groupData[index]['choosed'] = true;
                state.chooseId = newId;
                state.choosedGroup = state.groupData[index];
            }
        },
        [types.GROUP_ADD_SELECTED_GROUP_LIST](state, arr) {
            arr.forEach(item => {
                var hasPushed = UTILS.checkArrayInArray(state.selectedGroupDataList, item);
                console.log('hasPushed-------', hasPushed, state.selectedGroupDataList, item)
                if(!hasPushed){
                    state.selectedGroupDataList.push(item);
                }
            })
            console.log("types.GROUP_ADD_SELECTED_GROUP_LIST-----", state.selectedGroupDataList)
        },
        [types.GROUP_REMOVE_SELECTED_GROUP_LIST](state, arr) {
            arr.forEach(item => {
                var startIndex = UTILS.getArrayIndexInArray(state.selectedGroupDataList, item);
                if(startIndex != -1){
                    state.selectedGroupDataList.splice(startIndex, 1);
                }
            });
            console.log("types.GROUP_REMOVE_SELECTED_GROUP_LIST-----", state.selectedGroupDataList)
        },
        [types.GROUP_ADD_GROUP](state, groupName) {
            if (groupName != "") {
                API.addGroup({
                    'f_name': groupName.slice(0, 17)
                }, function (data) {
                    // 新增并选中新建分组
                    state.groupData = GROUP_DATA_MANAGER.addGroupData(state.groupData, data)
                    state.groupDataList = GROUP_DATA_MANAGER.getGroupDataList(state.groupData);
                    var index = UTILS.getIdIndexInObjectArray(state.groupData, data.id);
                    state.groupData[index]['choosed'] = true;
                    state.chooseId = data.id;
                    state.choosedGroup = state.groupData[index];

                    // 写入到localstorage 保存10分钟
                    var newTime = parseInt((new Date()).getTime());
                    localStorage.setItem('H5_Fate_NewGroup', data.id);
                    localStorage.setItem('H5_Fate_NewGroupTime', newTime)
                    console.log("types.GROUP_ADD_GROUP", state.groupData, data.id, newTime)
                })
            }
        },
        [types.GROUP_UPDATE_GROUP](state, groupData) {
            var newName = state.newGroupName;
            var groupIndex = UTILS.getIdIndexInObjectArray(state.groupData, groupData.id);
            var originData = state.groupData[groupIndex];
            API.updateGroup({
                'id': groupData.id,
                'f_name': newName
            }, function(data){
                if(data.ret){
                    console.log("修改成功", data);

                    // 更新列表数据的分组名
                    var newData = {
                        id: groupData.id,
                        name: newName
                    }
                    AppFate.$store.dispatch('record/updateRecordListGroupName', newData);

                    // 修改分组数据
                    originData['f_name'] = newName;
                }
            })
        },
        [types.GROUP_DELETE_GROUP](state, params) {
            API.deleteGroup({
                'id': params.groupId
            }, function (data) {
                state.groupData = GROUP_DATA_MANAGER.deleteGroupData(state.groupData, params.groupId);
                if(params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb();
                }
            }, function (data) {
                if(params.failCb && typeof(params.failCb) == 'function') {
                    params.failCb(data.status_code);
                }
            })
        },
        [types.GROUP_TOGGLE_GROUP_CHANGE](state, showChangeGroup) {
            state.showChangeGroup = showChangeGroup;
            if(showChangeGroup && state.groupDataList.length == 0){
                state.groupDataList = GROUP_DATA_MANAGER.getGroupDataList(state.groupData);
            }
        },
        [types.GROUP_CHANGE_GROUP](state, groupId) {
            var selectedList = state.selectedGroupDataList;
            var selectedIdList = [], allInTheSameGroup = false;
            for(var list of selectedList){
                selectedIdList.push(list[0]);
                allInTheSameGroup = list[1] == groupId ? true : false;
            }
            var selectedStr = selectedIdList.join(',');
    
            if(allInTheSameGroup){
                console.log("分组未发生改变，不发送请求");
                GROUP_DATA_MANAGER.changeGroupData(state.groupData, selectedList, groupId);
                setTimeout(() => {
                    selectedList.splice(0);
                }, 100);
                return;
            }

            // 发送批量修改分组的请求 
            API.changeGroup({
                'id': selectedStr,
                'f_group': groupId
            }, function(data){
                if(data.ret){
                    console.log("types.GROUP_CHANGE_GROUP---修改分组成功");
                    GROUP_DATA_MANAGER.changeGroupData(state.groupData, selectedList, groupId);
                    // 修改列表数据
                    var changeData = {selectedList: selectedList, groupId: groupId}
                    AppFate.$store.dispatch('record/updateRecordListGroupData', changeData);
                    setTimeout(() => {
                        selectedList.splice(0);
                    }, 100);
                }
            })
        },
        [types.GROUP_DELETE_GROUP_DATA](state) {
            var selectedList = state.selectedGroupDataList, deleteArr = [];
            for(var arr of selectedList) {
                deleteArr.push(arr[0])
            }
            var deleteId = deleteArr.join(',');
            API.deleteRecord({
                id: deleteId
            }, function (data) {
                if (data.ret) {

                    // 处理记录列表数据
                    AppFate.$store.dispatch('record/deleteRecordListData', deleteArr);
                    // 处理过滤数据
                    AppFate.$store.dispatch('record/updateRecordFilterList');
                    // 处理分组列表数据
                    state.groupData = GROUP_DATA_MANAGER.deleteGroupListGroupData(state.groupData, selectedList);
                    AppFate.$store.state.group.selectedGroupDataList.splice(0);
                }
            });
        },
        [types.GROUP_UPDATE_GROUP_DATA](state, data) {
            state.groupData = GROUP_DATA_MANAGER.updateGroupDataByData(state.groupData, data);
        },
        [types.GROUP_UPDATE_RECENT_GROUP_LIST](state, data) {
            let rList = [].concat(state.recentGroupList);
            let tempList = rList.filter(el => {return el.id == data.id}); //去重
                if(tempList.length > 0) { return; }
                rList.splice(0, 0, data);
                rList = rList.slice(0, 3);
            state.recentGroupList = [].concat(rList);
            window.localStorage.setItem('H5_Fate_GroupList', JSON.stringify(state.recentGroupList));
        }
    },
    actions: {
        initGroupList({ commit }, cbFunc){
            commit(types.GROUP_INIT_LIST, cbFunc)
        },
        initGroupListData({ commit }, data) {
            commit(types.GROUP_INIT_GROUP_LIST, data)
        },
        initGroupData({ commit }) {
            commit(types.GROUP_INIT_GROUP_DATA);
        },
        initGroupDefaultData({ state }) {
            state.checkedGroup = true;
            var defaultId = 0, 
                defaultIndex = UTILS.getIdIndexInObjectArray(state.groupData, defaultId),
                tempGroup = localStorage.getItem('H5_Fate_NewGroup'),
                tempIndex = UTILS.getIdIndexInObjectArray(state.groupData, tempGroup),
                tempTime = localStorage.getItem('H5_Fate_NewGroupTime'),
                newTime = parseInt((new Date()).getTime());
            var temp = parseInt((newTime - tempTime) / 1000 / 60);
            console.log('initGroupDefaultData-------', temp, tempGroup)
            if(temp <= 10) {
                if(state.groupData[tempIndex]) {
                    state.groupData[tempIndex]['choosed'] = true;
                    state.groupData[defaultIndex]['choosed'] = false;
                    state.chooseId = tempGroup;
                    state.choosedGroup = GROUP_DATA_MANAGER.getGroupDataById(state.groupData, tempGroup);
                }
            }
        },
        setGroupDefaultData({ state }, groupId) {

        },
        resetChooseGroupData({ commit }) {
            commit(types.GROUP_RESET_CHOOSE_GROUP_DATA);
        },
        addSelectedGroupList({ commit }, arr){
            commit(types.GROUP_ADD_SELECTED_GROUP_LIST, arr);
        },
        removeSelectedGroupList({ commit }, arr){
            commit(types.GROUP_REMOVE_SELECTED_GROUP_LIST, arr);
        },
        addGroup({ commit }, groupName){
            commit(types.GROUP_ADD_GROUP, groupName);
        },
        updateGroup({ commit }, groupData){
            commit(types.GROUP_UPDATE_GROUP, groupData);
        },
        deleteGroup({ commit }, params){
            commit(types.GROUP_DELETE_GROUP, params);
        },
        toggleChangeGroup({ commit }, showChangeGroup){
            commit(types.GROUP_TOGGLE_GROUP_CHANGE, showChangeGroup);
        },
        changeGroup({ commit }, groupId){
            commit(types.GROUP_CHANGE_GROUP, groupId);
        },
        deleteGroupListData({ commit }) {
            commit(types.GROUP_DELETE_GROUP_DATA);
        },
        updateGroupListData({ commit }, data) {
            commit(types.GROUP_UPDATE_GROUP_DATA, data);
        },
        resetSelectedGroupListData({ state, commit }) {
            let removeArr = [].concat(state.selectedGroupDataList);
            commit(types.GROUP_REMOVE_SELECTED_GROUP_LIST, removeArr);
            // 重置选中状态
            state.groupData.forEach(el => {
                el.group_list.forEach(gEl => {
                    gEl.selected = false;
                });
            })
        },
        updateRecentGroupList({ commit }, data) {
            commit(types.GROUP_UPDATE_RECENT_GROUP_LIST, data);
        }
    }
}